(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-header"]) return;
  try {
    
document.querySelectorAll('.lm-mobile-nav').forEach(menu=>{menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>menu.removeAttribute('open')));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.removeAttribute('open');menu.querySelector('summary').focus()}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lm-motion'))customElements.define('lm-motion',class extends HTMLElement{connectedCallback(){this.video=this.querySelector('video');this.button=this.querySelector('button');if(!this.video||!this.button)return;this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.manualPause=false;this.abort=new AbortController();const o={signal:this.abort.signal};this.button.hidden=false;this.button.addEventListener('click',()=>{this.manualPause=!this.video.paused;if(this.video.paused)this.play();else this.video.pause()},o);this.video.addEventListener('playing',()=>{this.video.classList.add('is-ready');this.button.textContent=this.button.dataset.pause;this.button.setAttribute('aria-label',this.button.dataset.pause)},o);this.video.addEventListener('pause',()=>{this.button.textContent=this.button.dataset.play;this.button.setAttribute('aria-label',this.button.dataset.play)},o);this.video.addEventListener('error',()=>{this.video.classList.remove('is-ready');this.button.hidden=true},o);this.reduce.addEventListener('change',()=>{if(this.reduce.matches)this.video.pause()},{signal:this.abort.signal});this.observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting&&!this.reduce.matches&&!this.manualPause&&!navigator.connection?.saveData)this.play();else if(!e.isIntersecting)this.video.pause()})},{threshold:.2});this.observer.observe(this);document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause()},{signal:this.abort.signal})}play(){if(!this.video.src)this.video.src=this.video.dataset.src;this.video.play().catch(()=>{})}disconnectedCallback(){this.observer?.disconnect();this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm2-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lm-catalog'))customElements.define('lm-catalog',class extends HTMLElement{connectedCallback(){this.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;this.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;if(!card.hidden)count++});const status=this.querySelector('[role=status]');status.textContent=count+' '+status.dataset.suffix}))}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm2-header"]) return;
  try {
    
document.querySelectorAll('.lm2-menu').forEach(menu=>{menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>menu.removeAttribute('open')));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.removeAttribute('open');menu.querySelector('summary').focus()}})});
document.querySelectorAll('.lm2-motion').forEach(button=>{const sync=()=>{const off=document.documentElement.dataset.lmMotion==='off';button.setAttribute('aria-pressed',String(off));button.setAttribute('aria-label',off?button.dataset.offLabel:button.dataset.onLabel)};try{document.documentElement.dataset.lmMotion=sessionStorage.getItem('lmMotion')||'on'}catch{}sync();button.addEventListener('click',()=>{const off=document.documentElement.dataset.lmMotion!=='off';document.documentElement.dataset.lmMotion=off?'off':'on';try{sessionStorage.setItem('lmMotion',off?'off':'on')}catch{}sync();document.dispatchEvent(new Event('lm:motion'))})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm2-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lm-product'))customElements.define('lm-product',class extends HTMLElement{connectedCallback(){
const pack=this.querySelector('.lm2-packshot');if(pack?.style.getPropertyValue('--pack-ratio')==='0.4561')this.setAttribute('data-bath','');
this.querySelectorAll('[data-gallery-target]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-gallery-target]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-gallery-panel]').forEach(p=>p.hidden=p.dataset.galleryPanel!==button.dataset.galleryTarget)}));
const modal=this.querySelector('dialog');this.querySelector('.lm2-zoom-open')?.addEventListener('click',()=>{modal.showModal();document.documentElement.style.overflow='hidden'});this.querySelector('.lm2-zoom-close')?.addEventListener('click',()=>modal.close());modal?.addEventListener('close',()=>{document.documentElement.style.overflow=''});modal?.addEventListener('click',e=>{if(e.target===modal)modal.close()});
this.querySelector('[data-variant]')?.addEventListener('change',e=>{const option=e.target.selectedOptions[0];const price=this.querySelector('[data-price]');if(price)price.textContent=option.dataset.price;const button=this.querySelector('[name=add]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url)});
}});

  } catch(e) { console.error(e); }
})();
})();
